
import { AdminTemplate, PendingPaymentsList } from "../../components";
export const PendingPayments = () => {
  return (
    <AdminTemplate
      headerProps={{
        hideAddButton: true,
        headerTitle: "Bekleyen Hakedişler Listesi",
        hideDownloadButton: true, 
        hideSearchBar: true,
      }}
      showHeaderTitle={true}>
    <PendingPaymentsList/>
    </AdminTemplate>
  );
};